export default "__VITE_ASSET__n5O2fF1B__"